import { Component, OnInit, EventEmitter, Output} from '@angular/core'; 
import { Brand } from '../../shared/models/Brand';
import { Mailing } from '../../shared/models/Mailing';
import { BrandService } from '../../shared/services/brand.service';
import { MailingService } from '../../shared/services/mailing.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
})
export class DashboardComponent{

  public brands: Brand[];
  public mailings: Mailing[];

  constructor(private brandService: BrandService, private mailingService: MailingService) { }

  // on component load
  ngOnInit() {
    this.brandService.getMostRecent().subscribe((result) => {
      if (result.length) {
        this.brands = result;
      }
    });
     
    this.mailingService.getMostRecent().subscribe((result) => {
      if (result.length) {
        this.mailings = result;
      }
    })
  } 
}
